import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY } from "../constants";
var es = /*#__PURE__*/_defineProperty({}, CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY, {
  MODULE_HOME: 'Inicio',
  MODULE_RECOGNITION: 'Reconocimiento',
  MODULE_PERFORMANCE: 'Desempeño',
  MODULE_CLIMATE: 'Clima',
  MODULE_LEARNING: 'E-Learning',
  MODULE_COMPANY: 'Compañía',
  MODULE_ANALYTICS: 'Analítica',
  MODULE_MY_RESULTS: 'Mis Resultados',
  TOOLTIP_CLIMATE_DESCRIPTION: 'Mide la cultura y satisfacción de tu equipo.',
  TOOLTIP_PERFORMANCE_DESCRIPTION: 'Evalúa el rendimiento, a través de objetivos y competencias.',
  TOOLTIP_LEARNING_DESCRIPTION: 'Gestiona estrategias de aprendizaje y potencia las habilidades de tus equipos.',
  TOOLTIP_RECOGNITION_DESCRIPTION: 'Gestiona las medallas otorgadas por los colaboradores.',
  TOOLTIP_COMPANY_DESCRIPTION: 'Monitorea tus procesos y genera reportes.',
  TOOLTIP_ANALYTICS_DESCRIPTION: 'Consulta los resultados de los procesos en los que participas.',
  TOOLTIP_MY_RESULTS_TITLE: 'Resultados',
  TOOLTIP_MY_RESULTS_DESCRIPTION: 'Analiza tus resultados y los del equipo que lideras.',
  SUBMODULE_RESULTS_TITLE: 'Mis resultados',
  SUBMODULE_TOOLTIP_MY_RESULTS_DESCRIPTION: 'Consulta los resultados de los procesos en los que participas',
  SUBMODULE_LEADER_RESULTS_TITLE: 'Mi equipo',
  SUBMODULE_TOOLTIP_LEADER_RESULTS_DESCRIPTION: 'Monitorea los resultados de tu equipo',
  SUBMODULE_DIRECTORY_TITLE: 'Directorio',
  SUBMODULE_TOOLTIP_DIRECTORY_DESCRIPTION: 'Información de los miembros de la compañía',
  SUBMODULE_COMPANY_CHART_TITLE: 'Organigrama',
  SUBMODULE_COMPANY_CHART_DESCRIPTION: 'Conoce la estructura de la compañía',
  SUBMODULE_RECOGNITION_TITLE: 'Medallas',
  SUBMODULE_TOOLTIP_RECOGNITION_DESCRIPTION: 'Envía medallas a tus compañero y mira las que recibiste',
  SUBMODULE_RECOGNITION_REDEMPTION_TITLE: 'Recompensas',
  SUBMODULE_TOOLTIP_RECOGNITION_REDEMPTION_DESCRIPTION: 'Canjea los puntos que obtuviste por tus logros',
  SUBMODULE_OKRS_PERFORMNACE_TITLE: 'OKRs',
  SUBMODULE_TOOLTIP_OKRS_PERFORMANCE_DESCRIPTION: 'Visualiza el progreso de la estrategia empresarial y reconoce el esfuerzo para cumplir los objetivos',
  SUBMODULE_GOALS_TITLE: 'Metas',
  SUBMODULE_TOOLTIP_GOALS_DESCRIPTION: 'Planea y establece tus compromisos de trabajo',
  SUBMODULE_COMPETENCES_TITLE: 'Evaluaciones',
  SUBMODULE_TOOTLTIP_COMPETENCES_DESCRIPTION: 'Accede a los cuestionarios de los procesos asignados',
  SUBMODULE_FEEDBACK_TITLE: 'Feedback',
  SUBMODULE_TOOLTIP_FEEDBACK_DESCRIPTION: 'Mide los procesos de feedback de tu compañía.',
  SUBMODULE_PID_TITLE: 'Plan individual de desarrollo',
  SUBMODULE_TOOLTIP_PID_DESCRIPTION: 'Crea procesos para cerrar brechas y promover el crecimiento.',
  SUBMODULE_SUCESSION_PLAN_TITLE: 'Plan de sucesión',
  SUBMODULE_TOOLTIP_SUCESSION_PLAN_DESCRIPTION: 'Crea planes de acción para futuras vacantes.',
  SUBMODULE_CLIMATE_EVALUATION_TITLE: 'Evaluaciones de Clima',
  SUBMODULE_TOOLTIP_CLIMATE_EVALUATION_DESCRIPTION: 'Accede al cuestionario para mediar el clima organizacional',
  SUBMODULE_SURVEY_TITLE: 'Encuestas',
  SUBMODULE_TOOLTIP_SURVEY_DESCRIPTION: 'Ayuda a tu empresa a recolectar información de manera rápida y sencilla',
  // Learning links
  LEARNING_LINK_LEARND_AND_PROGRESS: 'APRENDIZAJE Y PROGRESO',
  LEARNING_LINK_MORE_FOR_YOU: 'Más contenido',
  LEARNING_LINK_ENROLLED_COURSES: 'Cursos',
  LEARNING_LINK_TOOLTIP_MORE_FOR_YOU_DESCRIPTION: 'Descubre los nuevos contenidos de aprendizaje',
  LEARNING_LINK_PATHS: 'Rutas de aprendizaje',
  LEARNING_LINK_LIVE_SESSIONS: 'Sesiones en vivo',
  LEARNING_LINK_NOTES: 'Apuntes',
  LEARNING_LINK_STUDY_PLAN: 'Plan de estudios',
  LEARNING_LINK_TOOLTIP_STUDY_PLAN: 'Planifica tu meta de aprendizaje',
  LEARNING_LINK_MENTORSHIP: 'Mentorías',
  LEARNING_LINK_TOOLTIP_MENTORSHIP: 'Solicita asesorías con especialistas',
  LEARNING_LINK_BLOG: 'Blog',
  LEARNING_LINK_LIVES: 'Lives',
  LEARNING_LINK_TOOLS: 'Herramientas',
  LEARNING_LINK_EVALUATIONS_AND_GOALS: 'EVALUACIÓN Y LOGROS',
  LEARNING_LINK_SKILL_XP: 'Skill XP',
  LEARNING_LINK_PROJECTS: 'Proyectos',
  LEARNING_LINK_TOOLTIP_PROJECTS_DESCRIPTION: 'Lleva a cabo los proyectos de tus cursos',
  LEARNING_LINK_DIPLOMA: 'Diplomas',
  LEARNING_LINK_TOOLTIP_DIPLOMA_DESCRIPTION: 'Consulta los diplomas obtenidos por el cumplimiento de tu aprendizaje',
  LEARNING_LINK_PENDING_TESTS: 'Tests pendientes',
  LEARNING_LINK_DONE_TESTS: 'Tests resueltos',
  LEARNING_LINK_ACCHIEVEMENTS: 'Logros',
  LEARNING_LINK_REWARDS: 'Recompensas',
  LEARNING_LINK_SKILL_XP_EVOLUTION: 'Skill XP Evolution',
  LEARNING_LINK_TOOLTIP_SKILL_XP_EVOLUTION_DESCRIPTION: 'Toma los test e identifica el nivel de tus habilidades',
  LEARNING_LINK_GAMIFICATION: 'Gamificación',
  LEARNING_LINK_TOOLTIP_GAMIFICATION_DESCRIPTION: 'Gana recompensas por tus logros de aprendizaje',
  LEARNING_LINK_MY_COURSES: 'Mis cursos',
  LEARNING_LINK_TOOLTIP_MY_COURSES_DESCRIPTION: 'Accede a cursos y rutas en los que estás inscrito',
  LEARNING_LINK_RESOURCES: 'Recursos',
  LEARNING_LINK_TOOLTIP_RESOURCES_DESCRIPTION: 'Recursos de aprendizaje',
  LEARNING_LINK_COURSES: 'Cursos',
  LEARNING_LINK_DISCOVER: 'Descubre',
  LEARNING_LINK_KNOWLEDGE_HUB: 'Catálogo',
  // Misc
  SIDEBAR_BACK: 'Volver',
  SIDEBAR_BACK_TO_PRODUCTS: 'Volver a mis productos',
  SIDEBAR_EXPAND: 'Expandir menu',
  SIDEBAR_COLLAPSE: 'Colapsar menu',
  SIDEBAR_HELP: 'Ayuda',
  SIDEBAR_HELP_DESCRIPTION: 'Accede a los recursos y canal de soporte.',
  MODULE_PRODUCTS_SUBTITLE: 'PRODUCTOS'
});
export default es;